
const monthsKMList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
const monthsList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]

const api_production = "https://syslog-api.misti.gov.kh/api/v1";
const api_testing = "https://syslog-api.misti.dev/api/v1";
const api_dev = "http://localhost:81/api/v1";

let get_api = () => {
	let hostname = String(location.hostname);
	if(hostname.includes("misti.gov.kh")) return api_production;
	if(hostname.includes("misti.dev")) return api_testing;
	return api_dev;
}

const config = {
	api: get_api(),
	endpoint: "https://syslog.misti.gov.kh/send?",
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return [`${paddingDate}${date} ${monthsList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`, `${paddingDate}${date} ${monthsKMList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`]
	},
	orderlify: (number) => {
		let length = String(number).length;
		let padding = 6 - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (oldDate.getTime() - currentDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			let num = Math.floor(seconds / 31536000);
			return [num + " more years", "រយៈពេល " + num + " ឆ្នាំ"];

		} else if (seconds / 2592000 > 1) {
			let num = Math.floor(seconds / 2592000)
			return [num + " more months", "រយៈពេល " + num + " ខែ"];

		} else if (seconds / 86400 > 1) {
			let num = Math.floor(seconds / 86400);
			return [num + " more days", "រយៈពេល " + num + " ថ្ងៃ"];

		} else if (seconds / 3600 > 1) {
			let num = Math.floor(seconds / 3600);
			return [num + " more hours", "រយៈពេល " + num + " ម៉ោង"];

		} else if (seconds / 60 > 1) {
			let num = Math.floor(seconds / 60);
			return [num + " more minutes", "រយៈពេល " + num + " នាទី"];

		} else {
			return ["expired", "ផុតកំណត់"];
		}

	},

	getAge: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			let num = Math.floor(seconds / 31536000);
			return [num + " years ago", num + " ឆ្នាំមុន"];

		} else if (seconds / 2592000 > 1) {
			let num = Math.floor(seconds / 2592000)
			return [num + " months ago", num + " ខែមុន"];

		} else if (seconds / 86400 > 1) {
			let num = Math.floor(seconds / 86400);
			return [num + " days ago", num + " ថ្ងៃមុន"];

		} else if (seconds / 3600 > 1) {
			let num = Math.floor(seconds / 3600);
			return [num + " hours ago", num + " ម៉ោងមុន"];

		} else if (seconds / 60 > 1) {
			let num = Math.floor(seconds / 60);
			return [num + " minutes ago", num + " នាទីមុន"];

		} else {
			return ["Just now", "ឥឡូវនេះ"];
		}

	},

	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	translate(text, lang = 0) {
		let translate = text.split("||");

		lang = lang < translate.length ? lang : 0;
		if(translate.length - 1 <= lang) return translate[lang];
		else return translate;
	},
	clearList(array, lang = 0) {
		let data = [];
		for(let i = 0; i < array.length ;i++) {
			if(array[i].id == 1) continue;
			let name = String(array[i].name).split("||");
			lang = lang < name.length ? lang : 0;
			array[i].name = name[lang];
			data.push(array[i]);
		}
		return data;
	},
	translateList(array, lang = 0) {
		let data = [];
		for(let i = 0; i < array.length ;i++) {
			array[i].name = String(array[i].name).split("||")[lang];
			data.push(array[i]);
		}
		return data;
	},
	moneylify: (total, currency = "usd") => {
		// if (Number.isNaN(total)) total = 0;
		let sign = "", currency_view_front = "", currency_view_end = "";

		if (currency == 'khr') currency_view_front = "", currency_view_end = " ៛";
		if (currency == 'usd') currency_view_front = "$", currency_view_end = "";

		total = parseFloat(total).toFixed(2);

		if (total < 0) {
			sign = "-";
			total = total * -1.00;
		}

		let total_real = String(parseInt(total));
		let total_rational = String((total - parseInt(total)).toFixed(2));
		let output = "";
		if (total_real.length <= 3) {
			output = total_real;
		} else if (total_real.length <= 6) {
			output = total_real.slice(0, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else if (total_real.length <= 9) {
			output = total_real.slice(0, total_real.length - 6) + "," + total_real.slice(total_real.length - 6, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else {
			output = total_real;
		}

		return sign + currency_view_front + output + "." + total_rational.replace("0.", "") + currency_view_end;
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	isJWT: function (jwt) {
		let jwt_part = String(jwt).split(".");

		if(jwt_part.length !== 3) return {valid: false, data: {}};

		let data;
		try {
			data = JSON.parse(this.base64decode(jwt_part[1]));
		} catch (e) {
			return {valid: false, data: {}};
		}

		return {valid: true, data: data};
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getProfileUrl: (id = 'noavailable') => {
		return `https://oneme.oss-ap-southeast-7.aliyuncs.com/qr/${id}.jpg`;
	},
	getGender(t, lang = 0) {
		if (t == "o") return lang == 0 ? "Other" : "ផ្សេងទៀត";
		if (t == "f") return lang == 0 ? "Female" : "ស្រី";
		if (t == "m") return lang == 0 ? "Male" : "ប្រុស";
		return "Unknown";
	},
	getStatus(s) {
		if (s == "act") return "ដំណើរការ";
		if (s == "pnd") return "កំពុងរង់ចាំ";
		if (s == "pad") return "បានបង់ប្រាក់";
		if (s == "npd") return "មិនទាន់បង់ប្រាក់";
		if (s == "fin") return "បានបញ្ចប់";
		if (s == "nac") return "មិនដំណើរការ";
		if (s == "rcv") return "អ្នកទទួល";
		if (s == "snd") return "អ្នកផ្ញើរ";
		if (s == "ndv") return "មិនមានអ្នកដឹក";
		if (s == "wdv") return "រង់ចាំអ្នកដឹក";
		if (s == "dvr") return "កំពុងដឹកជញ្ជូន";
		if (s == "dlv") return "បានដល់អតិថិជន";
		if (s == "rtn") return "បានត្រឡប់";
		if(s == "sl") return "Accountant Administrator";
		if(s == "sa") return "Super Administrator";
		if(s == "ad") return "Operation Administrator";
		if(s == "ca") return "Call Center Administrator";
		return "មិនមាន";
	}
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js